import React from "react";
import { useTranslation } from "react-i18next";
import NavItem from "src/components/layout/LayoutCompany/NavItem";
import SubscribeCard from "src/components/promotion/cards/SubscribeCard";
import useTenant from "src/hooks/api/services/tenants/useTenant";
import useTeams from "src/hooks/api/services/users/useTeams";
import useAuth from "src/hooks/selectors/useAuth";
import useSubscription from "src/hooks/selectors/useSubscription";
import useLayout from "src/hooks/useLayout";
import { hexToRGB } from "src/lib/colors";

const NavItems = () => {
	const { t } = useTranslation(["layout"]);
	const auth = useAuth();
	const { layout } = useLayout();
	const { teams } = useTeams();
	const {
		tenant: { modules },
	} = useTenant();
	const subscription = useSubscription();

	return (
		<>
			<div
				className={`flex-1 flex flex-col ${
					layout.navbar.variant === "default" &&
					"xl:min-w-[272px] min-w-auto"
				}`}
			>
				<NavItem
					className="gtm-company-dashboard-sidebar--link-dashboard"
					to="/dashboard"
					icon="fas fa-home"
				>
					{t("nav-items.dashboard")}
				</NavItem>
				<NavItem
					className="gtm-company-dashboard-sidebar--link-opdrachten"
					to="/tasks"
					icon="fas fa-border-all"
					childItems={
						teams.length > 0
							? teams.map((team) => (
									<NavItem
										className="gtm-company-dashboard-sidebar--link-opdrachten"
										to={`/tasks/teams/${team.slug}`}
										icon={
											<div
												style={{
													height: 18,
													width: 18,

													backgroundColor: team.color
														? hexToRGB(
																team.color,
																0.15
														  )
														: "#ffff",

													color:
														team.color ||
														"var(--dark-color)",
												}}
												className="font-bold text-dark rounded-sm flex items-center justify-center"
											>
												<small>
													{team.name.charAt(0)}
												</small>
											</div>
										}
									>
										{team.name}
									</NavItem>
							  ))
							: undefined
					}
				>
					{t("nav-items.tasks")}
				</NavItem>
				<NavItem
					to="/inbox"
					count={auth?.unreads?.messages}
					icon="fas fa-comments"
				>
					{t("nav-items.messages")}
				</NavItem>
				{modules.includes("hour-validation") && (
					<NavItem
						className="gtm-company-dashboard-sidebar--link-studentenpool"
						to="/hours"
						icon="fas fa-alarm-clock"
						count={auth?.unreads?.hours}
					>
						{t("nav-items.hours")}
					</NavItem>
				)}
				{modules.includes("student-pool") && (
					<NavItem
						className="gtm-company-dashboard-sidebar--link-studentenpool"
						to="/network"
						icon="fas fa-users"
					>
						{t("nav-items.studentpool")}
					</NavItem>
				)}
				{modules.includes("talentboard") && (
					<NavItem
						to="/talents"
						count={auth?.unreads?.offers}
						icon="fas fa-users-crown"
					>
						{t("nav-items.talents")}
					</NavItem>
				)}
			</div>
			<div className="">
				{!subscription?.id && <SubscribeCard />}

				{/* {(auth.is_sales || auth.is_admin) && (
					<NavItem to={getEmployeeUrl()} icon="fas fa-lock">
						MW omgeving
					</NavItem>
				)} */}

				<NavItem icon="fas fa-comment-alt" to="/feedback">
					{t("nav-items.feedback")}
				</NavItem>

				<NavItem
					className="gtm-company-dashboard-sidebar--link-payments"
					to="/payments"
					count={auth?.unreads?.open_payments}
					icon="fas fa-credit-card"
				>
					{t("nav-items.payments")}
				</NavItem>
				<NavItem
					className="gtm-company-dashboard-sidebar--link-envelopes"
					to="/envelopes"
					count={auth?.unreads?.envelopes}
					icon="fas fa-file-signature"
				>
					{t("nav-items.agreements")}
				</NavItem>
				<NavItem to="/profile/show" icon="fas fa-user">
					{t("nav-items.my-profile")}
				</NavItem>
				<div className="block my-4"></div>
				{/* <NavItem
					onClick={handleLogout}
					loading={loggingOut}
					icon="fas fa-sign-out"
				>
					{t("nav-items.signout")}
				</NavItem> */}
			</div>
		</>
	);
};

export default NavItems;
